import { render, staticRenderFns } from "./TasksForm.vue?vue&type=template&id=2ea56ec4"
import script from "./TasksForm.vue?vue&type=script&lang=js"
export * from "./TasksForm.vue?vue&type=script&lang=js"
import style0 from "./TasksForm.vue?vue&type=style&index=0&id=2ea56ec4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports